import { SelectorData } from './selectorDataType';

export enum Regions {
  MEXICO = 1,
  BRAZIL = 2,
  COLOMBIA = 3,
  NOLA = 4,
  SOUTH = 5,
}

export const selectableRegions: SelectorData[] = [
  { label: 'Nola', value: Regions.NOLA },
  { label: 'Brazil', value: Regions.BRAZIL },
  { label: 'Mexico', value: Regions.MEXICO },
  { label: 'South', value: Regions.SOUTH },
  { label: 'Colombia', value: Regions.COLOMBIA },
];
